// Hackathon Organizer Logos
export const hackathonLogos = {
    // IEEE logos for IEEE-organized events
    ieee: '/assets/logos/hackathons/ieee-logo.png',

    // ESPRIT logo for AIxCyber hackathon
    esprit: '/assets/logos/hackathons/esprit-logo.png',

    // MIT Sloan AI Club logo for Hack-Nation
    mitSloan: '/assets/logos/hackathons/mit-sloan-logo.png',

    // Organisation Internationale de la Francophonie logo for D-Clickathon
    oif: '/assets/logos/hackathons/oif-logo.png',

    // Institut National Agronomique de Tunisie logo for AGROERA
    inat: '/assets/logos/hackathons/inat-logo.png',

    // SVG fallback for missing logos
    fallback: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+CiAgICA8cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iIzBkMGQwZCIgc3Ryb2tlPSIjNzMyNDI0IiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDx0ZXh0IHg9IjUwIiB5PSIzNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iI2Q5MjMyMyIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmb250LXdlaWdodD0iYm9sZCI+SEFDSzwvdGV4dD4KICAgIDx0ZXh0IHg9IjUwIiB5PSI1NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzdiN2I3YiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEwIj5MT0dPPC90ZXh0PgogICAgPGNpcmNsZSBjeD0iNTAiIGN5PSI3MCIgcj0iOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZDkyMzIzIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxwYXRoIGQ9Ik00NiA3MCBMNDggNzIgTDU0IDY2IiBzdHJva2U9IiNkOTIzMjMiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4='
};